import {getAllEmployees} from '../../services/EmployeeService';

//const employees= await getAllEmployees();
//const employeesTotalCount = employees.length;

let employeesTotalCount = 0;
let initPromise = null;

// Initialize employees ONCE
const initializeEmployees = async () => {
  if (initPromise) return initPromise; // Reuse existing promise

  initPromise = (async () => {
    try {
      const employees = await getAllEmployees();
      console.log('Employees loaded:', employees.length); // Debug
      employeesTotalCount = employees.length;
    } catch (error) {
      console.error('Failed to load employees:', error);
      // Optionally set a fallback or re-throw
      throw error;
    }
  })();

  return initPromise;
};

// Call this once at app startup (optional but recommended)
// Or let it lazy-initialize on first use
initializeEmployees(); 

export const getExpectedWorkHours = (period, year, month = null) => {
  const isWeekday = (date) => {
    const day = date.getDay(); // 0 = Sun, 1 = Mon, ..., 6 = Sat
    return day >= 1 && day <= 5; // Mon–Fri
  };

  const isSaturday = (date) => date.getDay() === 6;

  if (period === 'year') {
    let total = 0;
    for (let m = 0; m < 12; m++) {
      const daysInMonth = new Date(year, m + 1, 0).getDate();
      for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(year, m, d);
        if (isWeekday(date)) total += 8;
        else if (isSaturday(date)) total += 4;
      }
    }
    return total * employeesTotalCount;
  }

  if (period === 'month' && month) {
    let total = 0;
    const daysInMonth = new Date(year, month, 0).getDate();
    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month - 1, d); // month is 1-based
      if (isWeekday(date)) total += 8;
      else if (isSaturday(date)) total += 4;
    }
    return total * employeesTotalCount;
  }

  // Optional: handle 'week' if you re-enable it later
  return 44 * employeesTotalCount; // fallback
};

// Get expected worked days (Mon–Sat, excluding Sundays)
export const getExpectedWorkedDays = (period, year, month = null) => {
  const isWorkedDay = (date) => {
    const day = date.getDay(); // 0 = Sun, 1 = Mon, ..., 6 = Sat
    return day >= 1 && day <= 6; // Monday–Saturday
  };

  let workedDays = 0;

  if (period === 'year') {
    for (let m = 0; m < 12; m++) {
      const daysInMonth = new Date(year, m + 1, 0).getDate();
      for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(year, m, d);
        if (isWorkedDay(date)) workedDays++;
      }
    }
  } else if (period === 'month' && month) {
    const daysInMonth = new Date(year, month, 0).getDate();
    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month - 1, d);
      if (isWorkedDay(date)) workedDays++;
    }
  } else {
    // Optional: fallback for "week" (Mon–Sat)
    workedDays = 6;
  }

  return workedDays * employeesTotalCount;
};